import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const speech_bubble_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4.5,6.5 L19.5,6.5 L19.5,17.5 L9.75,17.5 L7.5,19.75
      L7.5,17.5 L4.5,17.5 L4.5,6.5 Z M7,9.479 L17.021,9.479 M6.979,11.5625 L17,11.5625 M6.979,
      13.5625 L14.958,13.5625"
      />
    </svg>
  );
};
